module.exports = __webpack_public_path__ + "img/Halle_Leer 084.620fd9ae.jpg";